import { Label } from "../../../typography/Label";
import { useMessage } from "../Context";

export function NominationDetails() {
    const { nomination } = useMessage();

    if (!nomination) {
        return null;
    }

    return (
        <div className="flex w-full flex-col items-start gap-16">
            <div className="flex w-full flex-col items-start gap-8">
                <Label size="small" weight="medium-bold">
                    Name
                </Label>

                <Label size="small" weight="regular" color="primary">
                    {nomination.name}
                </Label>
            </div>

            <div className="flex w-full flex-col items-start gap-8">
                <Label size="small" weight="medium-bold">
                    Phone number
                </Label>

                <Label size="small" weight="regular" color="primary">
                    {nomination.phone}
                </Label>
            </div>
        </div>
    );
}
